import { h, Fragment } from 'preact'
import classnames from 'classnames'


export function SavedJobsButton({ text, saved, unsave, save, ...props }) {

	const buttonClasses = classnames(
		props.class || props.className || '',
		'button button--small', 
		text && 'button--icon-left',
		!text && 'button--icon-only',
		saved && 'svg--heart-on'
	)
	
	delete props['class']
	delete props['className']

	const label = text ? (saved ? 'Saved' : 'Save') : ''
	return <>
		<button class={buttonClasses} alt={saved ? 'Saved' : 'Save job'} onClick={saved ? unsave : save} {...props}>
			<HeartSvg /> {label}
		</button>
	</>
}


const HeartSvg = () => <>
	<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path 
			class="svg-heart" 
			d="M8.29889 2.76461L9.00014 4.6104L9.70114 2.76452C10.2812 1.23721 12.0903 0.478066 13.9182 0.836513C15.6693 1.17991 17.25 2.53949 17.25 5.09314C17.25 7.60168 15.3198 11.2451 9 15.1231C2.68015 11.2451 0.75 7.60168 0.75 5.09314C0.75 3.77581 1.16249 2.80592 1.7601 2.12516C2.36419 1.43702 3.1933 1.00408 4.08238 0.832916C5.91206 0.480666 7.72265 1.24785 8.29889 2.76461Z" 
			stroke="#004F5D" 
			stroke-width="1.5"
		/>
	</svg>
</>